<script lang="ts" setup>
 import { i18n } from '@/plugins/i18n';
  interface FooterLink {
    name: string;
    to: string;
    permissions?: string;
  }

  const footerLinks:ComputedRef<FooterLink[]> = computed(() => [
    {
      name: i18n.global.t('terms_and_conditions'),
      to: '/terms-conditions',
    },
    {
      name: i18n.global.t('support'),
      to: '/admin/support',
    },
  ]);

</script>

<template>
    <div class="layout">
      <header class="layout__header">
        <div class="header__wrapper">
          <NuxtLink
            to="/"
            class="logo"
          >
            <img
              src="@/assets/images/nibe-logo.svg"
              width="80"
            />
          </NuxtLink>
  
          <NavigationUser />
        </div>
      </header>
  
      <div class="content_wrapper">
        <div class="layout__content flex min-h-full flex-col">
          <div class="w-full flex-auto justify-center">
            <main class="content__slot">
              <slot></slot>
            </main>
          </div>
          <div class="flex w-full">
            <div class="content__footer">
              <Card
                class="footer__wrapper"
                padding="xl"
              >
                <NuxtLink
                  v-for="(link, index) in footerLinks"
                  :key="`footer-link-${index}`"
                  :to="link.to"
                >
                  {{ link.name }}
                </NuxtLink>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<style lang="postcss" scoped>
  .layout {
    @apply h-screen w-screen;
    @apply max-h-screen max-w-[100vw];
    @apply min-h-screen min-w-[100vw];

    .layout__header {
      @apply w-full overflow-hidden;
      @apply h-[77px];
      @apply flex items-center justify-center;
      @apply bg-white;
      @apply border-b border-gray-300 border-opacity-70;

      @apply rounded-b-[16px];

      @media (min-width: 1024px) {
        @apply rounded-b-none;
      }

      .header__wrapper {
        @apply flex w-full max-w-container-xxl justify-between p-2 px-6;
      }
    }

    .content_wrapper {
      @apply lg:flex lg:flex-row-reverse w-full lg:max-w-container-xxl place-self-center;
      height: var(--content-height-without-header);
    }
    .layout__content {
      @apply w-full overflow-hidden;
      height: var(--content-height-without-footer);

      @media (min-width: 1024px) {
        @apply h-full;
      }

      @apply overflow-y-auto overflow-x-hidden;
      @apply bg-gray-50;

      /* @apply border border-green-500; */

      .content__slot {
        @apply min-h-full;
        @apply p-4;
        @apply py-6;
        @apply w-full;

      }

      .content__footer {
        @apply p-4;
        @apply py-6;
        @apply w-full;


        .footer__wrapper {
          @apply flex w-full justify-end p-2 px-6;

          a {
            @apply pl-12;
            color: var(--color-grey-pure);
            font-size: var(--font-size-xxs);
          }
        }
      }
    }

    .layout__navigation {
      @apply w-full overflow-hidden;
      @apply h-[58px];

      @apply border-t border-gray-300;
      @apply border-opacity-70;
      @apply rounded-t-2xl;

      @media (min-width: 1024px) {
        @apply h-full max-w-xs;
        @apply border-none;
        @apply shadow-none;
        @apply rounded-none;
        @apply shadow-none;
      }
    }
  }
</style>